import { render, staticRenderFns } from "./EtsyTransferShop.vue?vue&type=template&id=74809f33&scoped=true"
import script from "./EtsyTransferShop.vue?vue&type=script&lang=js"
export * from "./EtsyTransferShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74809f33",
  null
  
)

export default component.exports